import axios from 'axios'

console.log(process.env)
export default axios.create({
    baseURL: process.env.API_ROOT, // 接口地址   
    timeout: 5000
})
/**
 * http 请求基础类
 * https://blog.csdn.net/qq_1307495/article/details/109134377
 *
 */
 const request = ["post", "put", "patch"].reduce((request, method) => {
    /**
     *
     * @param url string 接口地址
     * @param data object get参数
     * @param options object axios 配置项
     * @param urlType object axios 请求接口路径域名区分
     * @returns {AxiosPromise}
     */
    request[method] = (url, data = {}, options = {},urlType) => {
      return baseRequest(
        Object.assign({ url, data, method ,urlType}, defaultOpt, options)
      );
    };
    return request;
  }, {});
  
  ["get", "delete", "head"].forEach(method => {
    /**
     *
     * @param url string 接口地址
     * @param params object get参数
     * @param options object axios 配置项
     * @param urlType object axios 请求接口路径域名区分
     * @returns {AxiosPromise}
     */
    request[method] = (url, params = {}, options = {}, urlType) => {
      return baseRequest(
        Object.assign({ url, params, method, urlType }, defaultOpt, options)
      );
    };
  });


// WEBPACK FOOTER //
// ./src/api/index.js